import { pageUrl } from './helpers/url.js';
// import Volumes from './Volumes.svelte'
// import VolumesClean from './VolumesClean.svelte'
import VolumesStrap from './VolumesStrap.svelte'

let targetDiv = document.querySelector('#svelte-app')
let url = pageUrl()


function pageRoute(url) {
	if (url == "pool-volume-calculator") return new VolumesStrap({target: targetDiv});
	// if (url == "volume-calc-clean") return new VolumesClean({target: targetDiv});
	// if (url == "volume-calc-strap") return new VolumesStrap({target: targetDiv});
	// else return new VolumesClean({target: targetDiv});
}

const app = pageRoute(url)

export default app;